import { useEffect } from 'react';
import { RECAPTCHA_PLATFORM } from './recaptcha-config';

export function useRecaptchaPlatform(enabled: boolean) {
  useEffect(() => {
    const styles = '.grecaptcha-badge { visibility: hidden; }';
    const css = document.createElement('style');
    css.type = 'text/css';
    css.appendChild(document.createTextNode(styles));
    document.head.appendChild(css);
  }, []);

  useEffect(() => {
    const id = 'recaptcha';
    const recaptchaScript = document.getElementById(id);
    if (enabled && !recaptchaScript) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = RECAPTCHA_PLATFORM;
      script.id = id;
      document.head.appendChild(script);
    }
  }, [enabled]);
}
